import type { FunctionComponent } from 'react';
import EnterpriseRatesContent from './Content';

const EnterpriseRates: FunctionComponent = function () {
  return <EnterpriseRatesContent />;
};

export default EnterpriseRates;
